import React from "react";
import Header from "./components/header/header";
import Footer from "./components/footer/footer";
import Why from "./components/why/why";
import Feature from "./components/feature/feature";
import Join from "./components/join/join";
import Intro from "./components/intro/intro";
import Difference from "./components/difference/difference";

export default function Landing() {
  return (
    <>
      <Header />
      <main className="main">
        <div style={{ overflow: "hidden" }}>
          <Intro />
          <div className="anchor" id="feature"></div>
          <Why />
        </div>
        <Difference />
        <Feature />

        <div className="anchor" id="contact"></div>

        <Join />
      </main>
      <Footer />
    </>
  );
}
